import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.exec";

/**
 * Name: 样式定制
 * desc: 点评app中部分组件颜色定制，浏览器中隐藏分享按钮
 * Author: DanielDing(dingtianxing@meituan.com)
 * Date: 2017-07-20
 */
import { env } from './env';
import { infoLog } from './log';

var setColor = function setColor() {
  var color = '#FFBD00'; // 默认美团颜色

  var colorRGB = '255, 176, 0'; // 颜色对应的rgb值

  if (env.app === 'dianping-nova' || env.appChannel === 'dianping') {
    color = '#f63';
    colorRGB = '255, 102, 51';
  } else if (env.appChannel === 'car') {
    color = '#209CFF';
    colorRGB = '32, 156, 255';
  } else if (env.appChannel === 'paotui' || env.app === 'waimai') {
    color = '#FFB000';
    colorRGB = '255, 176, 0';
  } else if (env.app === 'group') {
    color = '#ffc300';
    colorRGB = '255, 195, 0';
  }

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  } // queryString颜色定制


  if (env.mainColor && /[0-9A-F]{6}$/i.test(env.mainColor)) {
    infoLog("reportMc-" + env.mainColor, {
      tag: {
        mainColor: env.mainColor,
        href: window.location.href
      }
    }); // 存在颜色、同时是6位HEX十六进制格式

    var newColor = "#" + env.mainColor;
    var rgb = hexToRgb(newColor);

    if (rgb) {
      color = newColor;
      colorRGB = rgb.r + ", " + rgb.g + ", " + rgb.b;
    }
  }

  var styleStr = "\n      .detail-wrapper .header-part .header-btn{\n          color: " + color + ";\n      }\n      .btn-box .btn-submit {\n          border: 1px solid " + color + ";\n          background-color: " + color + ";\n          color: #fff;\n      }\n      .btn-box .btn{\n          border-color: " + color + ";\n      }\n      .btn.outline {\n          color: " + color + ";\n          background-color: transparent !important;\n      }\n      .btn.outline.disabled {\n        color: " + color + ";\n        border: 1px solid " + color + ";\n      }\n      .btn-box .only-save{\n        color: " + color + ";\n      }\n      .btn.disabled, .btn.disabled:active{\n        background: " + color + ";\n        border-color: " + color + ";\n      }\n      .suggest-close {\n          color: " + color + ";\n      }\n      .hotel-card .card-title .index-title .index-main .default-container .default-icon{\n        color: " + color + ";\n      }\n      .hotel-card .card-title .use-card{\n        color: " + color + ";\n      }\n      .form-item .cell .choose-item .icon-choose{\n        color: " + color + ";\n      }\n      .toggle:checked{\n        background: " + color + ";\n        border-color: " + color + ";\n      }\n      .modal .modal-box .btn{\n        color: " + color + ";\n      }\n      .delte-confirm .modal-box .btn-group .btn:last-of-type {\n        color: " + color + ";\n      }\n      .tab-wrap .tab-item-wrap .item-content-wrap.selected:after{\n        border-color: " + color + ";\n      }\n      .detail-content .electronic-button .ui-btn{\n        border-color: " + color + ";\n      }\n      .detail-content .electronic-button .ui-btn.download{\n        color: " + color + ";\n      }\n      .detail-content .electronic-button .ui-btn.normal-child{\n        background: " + color + ";\n      }\n      .download-content .btn-line .send-email{\n        border-color: " + color + ";\n        background: " + color + ";\n      }\n\n      .invoice-apply .invoice-apply-upper .icon-dark-success{\n        color: " + color + ";\n      }\n      .invoice-apply .invoice-apply-content .invoice-apply-left .icon-dark-success{\n        color: " + color + ";\n      }\n      .invoice-apply .invoice-apply-content .invoice-apply-left .circle-process.done{\n        background-color: rgba(" + colorRGB + ", 0.2)\n      }\n      .invoice-apply .invoice-apply-content .invoice-apply-left .circle-process.done .inner-circle{\n        background-color: " + color + ";\n      }\n      .btn-box .btn{\n        background-color: " + color + ";\n        border-color: " + color + ";\n      }\n      .replace-row .replace-icon-wrapper .icon-change{\n        color: " + color + ";\n      }\n      .replace-row .replace-icon-wrapper .select-button {\n        color: " + color + ";\n        border-color: " + color + ";\n      }\n      .required:before {\n        color: #F5222D;\n      }\n      .invoice-layer-list .layer-btn {\n        color: " + color + ";\n      }\n      .elec-confirm-alert .line .right .amount {\n        color: " + color + ";\n      }\n      .btn-group .button {\n        background-color: " + color + ";\n        border-color: " + color + ";\n      }\n      .follow-gongzhonghao-tips .gongzhonghao {\n        color: " + color + " !important;\n      }\n      .btn.outline:active {\n        color: " + color + ";\n      }\n      .invoice-status-area .eInvoice-success-icon {\n        color: " + color + " !important;\n      }\n  ";
  var style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = styleStr;
  document.getElementsByTagName('head')[0].appendChild(style);
};

setColor();
export default setColor;